import type { ButtonHTMLAttributes, ElementType, ReactNode } from "react";
import { cx } from "./cx";
import s from "./button.module.css";

export interface ButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children"> {
  variant?: "default" | "primary" | "plain";
  size?: "md" | "sm";
  /** Disables the button and swaps the label for `busyLabel`. There is no spinner (D55). */
  busy?: boolean;
  busyLabel?: string;
  /** Render as another element, e.g. a router `Link`. */
  as?: ElementType;
  children?: ReactNode;
  [extra: string]: unknown;
}

export function Button({ variant = "default", size = "md", busy, busyLabel = "Saving…", as: Tag = "button", className, children, disabled, type, ...rest }: ButtonProps) {
  const isButton = Tag === "button";
  return (
    <Tag
      className={cx(s.btn, variant !== "default" && s[variant], size === "sm" && s.sm, className)}
      data-variant={variant}
      data-size={size}
      {...(isButton ? { type: type ?? "button", disabled: disabled || busy } : { "aria-disabled": disabled || busy || undefined })}
      aria-busy={busy || undefined}
      {...rest}
    >
      {busy ? busyLabel : children}
    </Tag>
  );
}
